import * as React from 'react';
import * as Icon from '../data/icon';
import { baseIcon } from '../data/icon';
import { assert } from '../../lib/utils';

export default function ({ icon, playing, onSelect }: {
    icon: baseIcon,
    playing: boolean,
    onSelect: (url: string, action: 'play' | 'pause' | 'stop') => void,
}) {
    const style: React.CSSProperties = {
        position: 'absolute',
        left: `${icon.left}px`,
        top: `${icon.top}px`,
    }

    assert(typeof icon.command === 'string' && Icon.command.isUrl(icon.command), '');
    const url = icon.command;
    if (playing) {
        return (
        <div style={style}>
            <Pause onClick={() => onSelect(url, 'pause')}/>&nbsp;
            <Stop onClick={() => onSelect(url, 'stop')}/>
        </div>);
    } else {
        return (
        <div style={style}>
            <Play onClick={() => onSelect(url, 'play')}/>
        </div>);
    }
}

function Play({ onClick }: {
    onClick: (e: React.MouseEvent) => void,
}) {
    const style: React.CSSProperties = {
        width: '90px',
        height: '90px',
    }
    return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={style} onClick={onClick}>
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
    </svg>);
}

function Pause({ onClick }: {
    onClick: (e: React.MouseEvent) => void,
}) {
    const style: React.CSSProperties = {
        width: '90px',
        height: '90px',
    }
    return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={style} onClick={onClick}>
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z"/>
    </svg>);
}

function Stop({ onClick }: {
    onClick: (e: React.MouseEvent) => void,
}) {
    const style: React.CSSProperties = {
        width: '90px',
        height: '90px',
    }
    return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={style} onClick={onClick}>
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3z"/>
    </svg>);
}
